/* eslint-disable immutable/no-mutation,no-unused-expressions */
export default class InfiniteScroll {
  constructor({
    totalPages,
    currentPage,
    element,
    onLoad,
    loadEdgeOffset = 100,
    loaderHeight = 0,
    useWindowAsScrollContainer = false,
    type = 'upper',
    isLoadAtStart = false,
  }) {
    this.element = element;
    this.loadEdgeOffset = loadEdgeOffset;
    this.loaderHeight = loaderHeight;
    this.onLoad = onLoad;
    this.useWindowAsScrollContainer = useWindowAsScrollContainer;

    // can be 'upper' or 'lower'
    this.type = type;
    this.isCanCallLoad = isLoadAtStart;

    this.subscribe();
    this.scrollToTop();
    this.totalPages = totalPages;
    this.currentPage = currentPage;
  }

  scrollToTop = () => {
    if (this.useWindowAsScrollContainer) {
      window.scrollTo(0, 0);
    } else if (this.element) {
      this.element.scrollTop = 0;
    }
  };

  scrollToDown = () => {
    if (this.useWindowAsScrollContainer) {
      window.scrollTo(0, window.innerHeight);
    } else {
      this.element.scrollTop = this.element.scrollHeight;
    }
  };

  subscribe = () => {
    if (this.useWindowAsScrollContainer) {
      window.addEventListener('scroll', this.handleScroll);
    } else {
      this.element &&
        this.element.addEventListener('scroll', this.handleScroll);
    }
  };

  unsubscribe = () => {
    if (this.useWindowAsScrollContainer) {
      window.removeEventListener('scroll', this.handleScroll);
    } else {
      this.element &&
        this.element.removeEventListener('scroll', this.handleScroll);
    }
  };

  handleScroll = () => {
    if (this.currentPage < this.totalPages) {
      if (this._getScrollOffset() === 0) {
        this.element.scrollTop =
          this._getClientHeight() + this._getScrollOffset();
      }
    }
    if (this.type === 'lower') {
      this._calculateLowerScroll();
    } else if (this.type === 'upper') {
      this._calculateUpperScroll();
    }
  };

  setCurrentPage = value => {
    this.currentPage = value;
  };

  setTotalPages = value => {
    this.totalPages = value;
  };

  _calculateUpperScroll() {
    if (
      this._getScrollOffset() > 0 &&
      this._getScrollOffset() < this.loadEdgeOffset
    ) {
      if (this.isCanCallLoad) {
        if (this.onLoad) this.onLoad();
      }
      this.isCanCallLoad = false;
    }
    if (this._getScrollOffset() > this.loadEdgeOffset + this.loaderHeight) {
      this.isCanCallLoad = true;
    }
  }

  _calculateLowerScroll() {
    if (
      this._getContainerHeight() <
      this._getClientHeight() + this._getScrollOffset() + this.loadEdgeOffset
    ) {
      if (this.isCanCallLoad) {
        if (this.onLoad) this.onLoad();
      }
      this.isCanCallLoad = false;
    }
    if (
      this._getContainerHeight() >
      this._getClientHeight() +
        this._getScrollOffset() +
        this.loadEdgeOffset +
        this.loaderHeight
    ) {
      this.isCanCallLoad = true;
    }
  }

  _getContainerHeight() {
    if (this.useWindowAsScrollContainer) {
      return document.body.scrollHeight;
    }
    return this.element.scrollHeight;
  }

  _getClientHeight() {
    if (this.useWindowAsScrollContainer) {
      return window.innerHeight;
    }
    return this.element.clientHeight;
  }

  _getScrollOffset() {
    if (this.useWindowAsScrollContainer) {
      return window.pageYOffset;
    }
    return this.element.scrollTop;
  }
}



// WEBPACK FOOTER //
// ./src/utils/infiniteScroll.js